module.exports = __webpack_public_path__ + "media/newstyle/images/third-circle-153fcbb9c3ee2146fcf68eb7ae708f18.svg";